<template>
    
    <div class="thumbnail">

        <img
            class="thumbnail__img"
            height="50"
            width="50"
            :src="src" />

    </div>

</template>

<script>
import { useConfig } from '@/helpers/config';

export default {

    props: {
        article: Object
    },

    computed: {

        src: function() {
            return ( useConfig().BASE_URL || '' ) + this.article.thumbnail.src
        }
    }
    
}
</script>

<style scoped>

.thumbnail {
    display: flex;
    justify-content: center;
    align-items: center;
}   

.thumbnail .thumbnail__img {
    width: 50px;
    min-width: 50px;
    height: 50px;
}

.thumbnail .thumbnail__img.thumbnail__img--replace {
    display: block;
    background-color: #eeeeee;
}   

</style>